import { Injectable, isDevMode, inject } from '@angular/core';
import {AuthService} from './auth.service';


@Injectable({
  providedIn: 'root'
})
export class LogService {
  private auth = inject(AuthService);


  canLog() {
    return this.auth.isGod() || isDevMode();
  }

  log(...msg: any) {
    if (this.canLog()) {
      console.log(...msg);
    }
  }

  error(...msg: any) {
    if (this.canLog()) {
      console.error(...msg);
    }
  }

  warn(...msg: any) {
    if (this.canLog()) {
      console.warn(...msg);
    }
  }

  time(timeName: string) {
    if (this.canLog()) {
      console.time(timeName);
    }
  }

  timeEnd(timeName: string) {
    if (this.canLog()) {
      console.timeEnd(timeName);
    }
  }
}
